
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { amountFormatUse, getToken } from '../../../helpers/Helper';
import { POST_CHEQUE_ISSUED_LIST, POST_CHEQUE_PRINT, POST_CHEQUE_EXPORT } from '../../../helpers/url_helper';
import ReactDOM from 'react-dom/client';
import { toast } from 'react-toastify';

import useMounted from '../../../hooks/useMounted';
import { post } from '../../../helpers/api_helper';


import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";
import { useTranslation } from 'react-i18next';
import Loader from '../../../components/Loader';

import PrintRight from './../../../assets/img/print-right.jpg';
import PrintCenter from './../../../assets/img/print-center.jpg';

const UserRoles = (props) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [isLoader, setLoader] = useState(0);
    const [id, setId] = useState(0);


    useMounted(() => {
        get_user()
    })

    const get_user = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [7] },
                    { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    $.ajax({
                        "url": POST_CHEQUE_ISSUED_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "chequeId" },
                    { "data": "bankName" },
                    { "data": "name" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {amountFormatUse(data.amount)}
                            </>)
                        }
                    },
                    { "data": "date" },
                    { "data": "chequeType" },
                    { "data": "chequeNumber" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button className="btn btn-sm text-success mr-2" type='button' onClick={() => { setId(data.chequeId) }} data-bs-toggle="modal" data-bs-target="#printModal"><i className="bx bx-printer"></i></button>
                                {data.isPrint === 'No' && <button className="btn btn-sm text-primary mr-2" onClick={() => { navigate('/cheque-issued/edit/' + data.chequeId); }} ><i className="bx bx-edit"></i></button>}
                            </>)
                        }
                    },
                ]
            });
        }
    }
    const [pdfUrl, setPdfUrl] = useState("");
    const print = (id, printType = 'center') => {
        const fetchPdf = async () => {
            setLoader(1);
            const response = await fetch(POST_CHEQUE_PRINT + "?id=" + id + "&printType=" + printType, {
                method: "GET",
                headers: {
                    Authorization: `${getToken()}`,
                    "Content-Type": "application/pdf",
                },
            });
            if (response.ok) {
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                setPdfUrl(url);
            }
            setLoader(0);
        };
        fetchPdf()
    }

    const exportToCSV = async () => {
        SetButtonDisabled(true)
        const filename = `Cheque-Issued-${new Date().toISOString().split('T')[0]}.csv`;
        const csvRows = [];

        csvRows.push(["Sr","Cheque Issue Date", "Bank Name", "Name", "Amount", "Date", "Cheque Type", "Cheque Number"]);
        var api_res = await post(POST_CHEQUE_EXPORT, {});
        if (!api_res.status) {
            toast.error(api_res.message);
            SetButtonDisabled(false)
            return;

        }

        // Loop over rows
        var i = 1;
        for (const row of api_res.data.issuedChequeList) {
            const values = [
                i++,
                row.createdAt,
                row.bankName,
                row.name,
                amountFormatUse(row.amount),
                row.date,
                row.chequeType,
                row.chequeNumber,
            ];

            // Escape values for CSV
            const escapedValues = values.map(v =>
                `"${(v ?? '').toString().replace(/"/g, '""')}"`
            );
            csvRows.push(escapedValues.join(','));
        }

        // Create blob and trigger download
        const BOM = '\uFEFF'; // This fixes â‚¹ issue in Excel
        const blob = new Blob([BOM + csvRows.join('\n')], {
            type: 'text/csv;charset=utf-8;',
        });

        // const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('hidden', '');
        a.setAttribute('href', url);
        a.setAttribute('download', filename);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        SetButtonDisabled(false)
    };


    return (
        <>
            {isLoader > 0 && <Loader />}
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>{t('chequeIssued.ticketList.chequeIssued')}</h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                    <button type='button' disabled={ButtonDisabled} onClick={exportToCSV} className='btn btn-sm btn-info me-3'>{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {!ButtonDisabled && <i className="fa fa-download me-2"></i>} Export</button>
                                    <Link to="/cheque-issued/add" className='btn btn-sm btn-primary'>+ {t('chequeIssued.ticketList.chequeIssue')}</Link>
                                </div>
                            </div>
                            <hr />
                            <div className='table-responsive text-nowrap'>
                                <table id="dataTableExample" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>Id</td>
                                            <td>{t('chequeIssued.ticketList.bankName')}</td>
                                            <td>{t('chequeIssued.ticketList.name')}</td>
                                            <td>{t('chequeIssued.ticketList.amount')}</td>
                                            <td>{t('chequeIssued.ticketList.date')}</td>
                                            <td>{t('chequeIssued.ticketList.chequeType')}</td>
                                            <td>{t('chequeIssued.ticketList.chequeNumber')}</td>
                                            <td>{t('chequeIssued.ticketList.action')}</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <iframe title='Print' src={pdfUrl} style={{ "display": "none" }}></iframe>

            <div className="modal fade" id="printModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Cheque Print</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-sm-6 mb-3 text-center'>
                                    <img src={`${PrintCenter}`} width={`100%`} height={"300px"} style={{ "border": "2px solid rgb(237, 237, 237)", "borderRadius": "10px", "padding": "7px" }} alt='print center' /><br />
                                    <button onClick={() => { print(id, 'center') }} data-bs-dismiss="modal" className="btn btn-primary mt-3">Print</button>
                                </div>
                                <div className='col-sm-6 mb-3 text-center'>
                                    <img src={`${PrintRight}`} width={`100%`} height={"300px"} style={{ "border": "2px solid rgb(237, 237, 237)", "borderRadius": "10px", "padding": "7px" }} alt='print right' /><br />
                                    <button onClick={() => { print(id, 'right') }} data-bs-dismiss="modal" className="btn btn-primary mt-3">Print</button>
                                </div>
                                {/* <div className='col-sm-4 mb-3 text-center'>
                                    <img src={`${PrintRight}`} width={`100%`} height={"300px"} style={{"border": "2px solid rgb(237, 237, 237)", "borderRadius" : "10px", "padding": "7px"}} alt='print right'/><br/>
                                    <button onClick={() => {print(id,'protected')}} data-bs-dismiss="modal" className="btn btn-primary mt-3">Print</button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserRoles;